import { createContext } from "react";

const ColorModeContext = createContext({
  toggleColorMode: () => {},
  mode: "light",
  setPrimaryColorLight: () => {},
  setPrimaryColorDark: () => {},
  setAppLogoLight: () => {},
  setAppLogoDark: () => {},
  setAppLogoFavicon: () => {},
  setAppName: () => {},
  setLoginBackgroundColor: () => {},
  appLogoLight: "",
  appLogoDark: "",
  primaryColorLight: "#1E3A8A",
  primaryColorDark: "#60A5FA",
  appName: "OnTicket",
  appLogoFavicon: "",
  loginBackgroundColor: "",
});

ColorModeContext.calculatedLogoLight = (
  appLogoLight,
  appLogoDark,
  defaultLogoLight
) => {
  if (appLogoLight) return appLogoLight;
  if (appLogoDark) return appLogoDark;
  return defaultLogoLight;
};

ColorModeContext.calculatedLogoDark = (
  appLogoLight,
  appLogoDark,
  defaultLogoDark
) => {
  if (appLogoDark) return appLogoDark;
  if (appLogoLight) return appLogoLight;
  return defaultLogoDark;
};

export default ColorModeContext;
